// Query string for one netcountable-e2ee call: the whitelisted keys that
// actually have a value.
//
// The generated apiGatewayCore clients copy EVERY whitelisted key out of the
// params object (utils.parseParametersToObject) and both query builders then
// stringify whatever they got, so a key the caller never set still goes on the
// wire as the literal "undefined" (or "null": store.state.deviceUUID's default
// on the desktop). The account service tolerates "null", the e2ee service
// tolerates both, and the e2ee client grew a whitelist per operation to dodge
// the rest. That is how deviceUUID ended up left off every e2ee call, and
// inside the Android app's WebView (signed in as the DEVICE's Cognito identity)
// the key layer then could not map the caller to the account: 403 NOT_A_MEMBER
// on every read and no passkey card in the unlock dialog (2026-10-14).
//
// `defaults` are session-wide params the call site does not know about (the
// app's deviceUUID, see E2eeApi.init); an explicit param of the same name wins.
export function queryParamsFor(params, names, defaults) {
  const explicit = params || {}
  const fallback = defaults || {}
  const out = {}
  for (const name of names) {
    const value = explicit[name] ?? fallback[name]
    if (value === undefined || value === null || value === '') continue
    out[name] = value
  }
  return out
}
